<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="journal-text" class="icon"></b-icon>
            <span>ข้อมูลหมายเหตุ</span>
            <button class="edit" @click="toggleEditStore()">
                <b-icon icon="pencil-fill"></b-icon>
            </button>
        </div>
        
        <div class="content">
            <div class="form" v-if="formData">
                <div class="row">
                    <div class="col-12">
                        <label>หมายเหตุใบเสร็จรับเงิน</label>
                    </div>
                    <div class="col-12">
                        <div class="field">
                            <textarea
                                rows="5"
                                class="input-field"
                                :class="{ 'reader': !isEditStore, 'invalid': errorData.receipt.blank }"
                                maxlength="1000"
                                placeholder="หมายเหตุใบเสร็จรับเงิน"
                                v-model="formData.remark.receipt"
                                :readonly="!isEditStore">
                            </textarea>
                            <div class="input-error-message" v-if="errorData.receipt.blank">โปรดกรอกหมายเหตุใบเสร็จรับเงิน</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <label>หมายเหตุใบรับเคลม</label>
                    </div>
                    <div class="col-12">
                        <div class="field">
                            <textarea 
                                rows="5"
                                class="input-field"
                                :class="{ 'reader': !isEditStore, 'invalid': errorData.claim.blank }"
                                maxlength="1000"
                                placeholder="หมายเหตุใบรับเคลม"
                                v-model="formData.remark.claim"
                                :readonly="!isEditStore" />
                            <div class="input-error-message" v-if="errorData.claim.blank">โปรดกรอกหมายเหตุใบรับเคลม</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <label>หมายเหตุใบตรวจสภาพ</label>
                    </div>
                    <div class="col-12">
                        <div class="field">
                            <textarea 
                                rows="5"
                                class="input-field"
                                :class="{ 'reader': !isEditStore, 'invalid': errorData.inspection.blank }"
                                maxlength="1000"
                                placeholder="หมายเหตุใบตรวจสภาพ"
                                v-model="formData.remark.inspection"
                                :readonly="!isEditStore" />
                            <div class="input-error-message" v-if="errorData.inspection.blank">โปรดกรอกหมายเหตุใบรับเคลม</div>
                        </div>
                    </div>
                </div>

                <div class="mt-3 text-center" v-if="isEditStore">
                    <button class="btn btn-main" @click="saveStore()">บันทึก</button>
                    <button class="btn btn-grey-outline" @click="cancel()">ยกเลิก</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '@/resources/Helper';

export default {
    data() {
        return {
            isEditStore: false,
            displayData: null,
            formData: null,
            errorData: this.initValidateData()
        }
    },
    props: {
        fieldData: Object
    },
    watch: {
        fieldData(value) {
            this.setData(value);
        }
    },
    methods: {
        initValidateData() {
            return {
                receipt: { blank: false },
                claim: { blank: false },
                inspection: { blank: false }
            }
        },
        toggleEditStore() {
            this.isEditStore = true;
        },
        setData(data) {
            this.displayData = data;
            this.formData = Helper.cloneObject(this.displayData);
        },
        saveStore() {
            if (this.validateData()) {
                this.isEditStore = false;
                this.displayData = Helper.cloneObject(this.formData);

                this.$emit('saveData', {
                    group: 'remark',
                    data: this.displayData
                });
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (!this.formData.remark[property] || !this.formData.remark[property].trim()) {
                    this.errorData[property].blank = true;
                    valid = false;
                }
            }

            return valid;
        },
        cancel() {
            this.isEditStore = false;
            this.errorData = this.initValidateData();
            this.formData = Helper.cloneObject(this.displayData);
        }
    }
}
</script>